import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SurveyTranslationsResponse, Translation } from '../models/surveytranslations-response.interface';
import { UserStoreService } from './user-store.service';

type TranslationResult = {
  status: "OK" | "KO";
  code: "UPDATE" | "CREATE" | "NOP" | "ERR001" | "GE";
  shortDescription: string;
  fullDescription: string;
};

export interface ApiPutSurveyTranslationsResponse {
  organizationId: string;
  surveyId: string;
  translations: { item: { questionCode: string; culture: string; choiceValue: string | null; localizedText: string }; result: TranslationResult }[];
  additionalTranslations: { item: { label: string; culture: string; category: string; localizedText: string }; result: TranslationResult }[];
}

@Injectable({ providedIn: 'root' })
export class ApiSurveyTranslationsService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/surveytranslations';

  constructor(
    private http: HttpClient,
    private userStore: UserStoreService) {}

  getSurveyTranslations(organizationId: string, surveyId: string): Observable<SurveyTranslationsResponse> {
    const params = new HttpParams()
      .set('organization', organizationId)
      .set('survey', surveyId);

    return this.http.get<SurveyTranslationsResponse>(`${this.apiBaseUrl}${this.apiPath}`, {params})
  }

  updateSurveyTranslations(organizationId: string, surveyId: string, translations: Translation[]): Observable<ApiPutSurveyTranslationsResponse> {
    //Prevent update of other surveys during development, unless the user is a SuperAdmin
    if(organizationId != 'a535f93d-f8c7-421d-a9c9-74f7a17e3761' && !this.userStore.isSuperAdmin()){
      return throwError(() => new Error('This organization/survey is not editable.'));
    }

    const request = {
      organization: organizationId,
      survey: surveyId,
      translations: translations
    }

    return this.http.put<ApiPutSurveyTranslationsResponse>(`${this.apiBaseUrl}${this.apiPath}`, request);
  }
}